"use strict";

var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

const HEADER = document.getElementById("header");

(() => {
	document.documentElement.style.setProperty("--header-height", `${HEADER.clientHeight + HEADER.offsetTop}px`);

	window.addEventListener('scroll', scrollW);

	// Remove empty <p> tags created by TinyMCE

	for (const p of document.getElementsByTagName("p")) {
		p.innerHTML.trim() === '' && p.remove();
	}

	// ScrollTo Animation

	//window.location.hash && animateTo(window.location.hash.substring(1));

	document.querySelectorAll('[href*="#"]:not([data-lbx]').forEach(cta => {
		let target = cta.hash.substring(1);

		if (!document.getElementById(target))
			return;

		cta.addEventListener("click", (e) => {
			e.preventDefault();

			e.target.closest("#main-menu") && document.getElementById("main-menu").classList.remove("active");

			animateTo(target);
		});
	});

	// Toggle Buttons

	document.querySelectorAll(".js-toggle").forEach(btn => {
		let target = document.getElementById(btn.dataset.target);

		if (!target)
			return;

		btn.addEventListener("click", (e) => {
			e.preventDefault();
			target.classList.toggle("active");
		});
	});

	const toggleGroups = new Map();

	document.querySelectorAll(".js-toggle-active").forEach((el, idx) => {
		const groupKey = el.dataset.group || idx;
		const panel = el.nextElementSibling && el.nextElementSibling.hasAttribute("aria-expanded") && el.nextElementSibling;

		el.classList.contains("active") && toggleGroups.set(groupKey, { summary: el, content: panel });

		el.addEventListener("click", () => {
			const currentlyActive = toggleGroups.get(groupKey);

			if (currentlyActive && currentlyActive.summary !== el) {
				currentlyActive.summary.classList.remove("active");
				currentlyActive.content.setAttribute("aria-expanded", false);
			}

			el.classList.toggle("active");
			panel && panel.setAttribute("aria-expanded", el.classList.contains("active"));

			if (el.classList.contains("active"))
				toggleGroups.set(groupKey, { summary: el, content: panel });
			else
				toggleGroups.delete(groupKey);
		});
	});

	// Set Up Animations

	addAnimations(".global-sitemap", "top");
	addAnimations(".text-modules", "top");

	// Custom animation observer

	const animationObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				let element = entry.target;
				element.classList.add("fade-in");
				animationObserver.unobserve(element);
			}
		});
	});

	new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			mutation.addedNodes.forEach(node => {
				if (node.nodeType === 1) {
					node.matches(".animate-fade") && animationObserver.observe(node);

					node.querySelectorAll(".animate-fade").forEach(element => animationObserver.observe(element));
				}
			});
		});
	}).observe(document.getElementById("content"), { childList: true, subtree: true });

	// Custom functions

	const resizeObserver = new ResizeObserver(entries => {
		entries.forEach(entry => {
			const element = entry.target;

			element.dataset.target
				? document.getElementById(element.dataset.target).style.setProperty("--offset", `${element.scrollHeight}px`)
				: element.style.setProperty("--offset", `${element.scrollHeight}px`);
		})
	})

	document.querySelectorAll(".js-offset").forEach(element => resizeObserver.observe(element));
})();

function scrollW() {
	const scrollTop = document.documentElement.scrollTop;

	if (scrollTop < 80) {
		HEADER.classList.remove('up', 'down');
	} else {
		HEADER.classList.toggle('down', scrollTop > lastScrollTop);
		HEADER.classList.toggle('up', scrollTop <= lastScrollTop);
	}

	lastScrollTop = Math.max(scrollTop, 0);  // Ensure lastScrollTop doesn't go below 0
}

function animateTo(target) {
    const toTarget = document.getElementById(target);
    if (!toTarget) return;

    const headerEl = document.getElementById("header") || document.getElementsByTagName("header")[0];
    const from = window.pageYOffset || window.scrollY || 0;
    const absTop = toTarget.getBoundingClientRect().top + from;

    const isMobile = window.matchMedia('(max-width: 639px)').matches;

    let to;
    if (isMobile) {
        const headerOffset = headerEl ? (headerEl.clientHeight + headerEl.offsetTop) : 0;
        to = absTop - (headerOffset - 150);
    } else {
        const headerRects = headerEl.getBoundingClientRect();
        to = absTop - ((headerRects.height + headerRects.top) * 2);
    }

    const duration = 3000;
    const start = performance.now();
    const easeInOutQuart = t => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;

    function step(timestamp) {
        const time = timestamp - start;
        const progress = Math.min(time / duration, 1);
        const y = easeInOutQuart(progress) * (to - from) + from;
        window.scrollTo(0, y);
        if (time < duration) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
}

function addAnimations(selector, behavior = null) {
	for (const item of document.querySelectorAll(selector)) {
		item.classList.add("animate-fade", behavior);
	}
}

(function(){
	if (window.matchMedia("(max-width: 1024px)").matches) {

		const expandLinks = document.querySelectorAll('.expand-submenu');

		expandLinks.forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				const parentItem = link.closest('.inner ul li');
				const submenu = parentItem.querySelector('.sub-sub-menu');

				const isOpen = parentItem.classList.contains('active-menu');
				document.querySelectorAll('.inner ul li.active-menu')
					.forEach(item => {
						item.classList.remove('active-menu');
						const sub = item.querySelector('.sub-sub-menu');
						if (sub) sub.setAttribute('aria-hidden', 'true');
					});

				parentItem.classList.toggle('active-menu', !isOpen);
				submenu.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
			});

		});

	}

	if(window.innerWidth < 600) {
		document.querySelectorAll('.sub-menu__hold').forEach(menu => {
			const nav = menu.querySelector('.sub-menu');
			const list = nav.querySelector('ul');
			const active = nav.querySelector('a.active') || nav.querySelector('a');

			if (!active) return;

			// crear botón visible
			const trigger = document.createElement('button');
			trigger.className = 'sub-menu__trigger';
			trigger.type = 'button';
			trigger.textContent = active.textContent;

			menu.prepend(trigger);

			// estado inicial
			menu.classList.add('dropdown-ready');

			// toggle dropdown
			trigger.addEventListener('click', () => {
				menu.classList.toggle('open');
			});

			// cerrar al click afuera
			document.addEventListener('click', e => {
				if (!menu.contains(e.target)) {
				menu.classList.remove('open');
				}
			});
		});

	}

	/* if (window.innerWidth > 900) {
		const itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
		let customCounter = 0;

		itemsMenu.forEach((itemMenu) => {
			const submenu = itemMenu.querySelector('.submenu:not(.submenu .submenu)');
			if (!submenu) return;

			const submenuItems = submenu.querySelectorAll(':scope > li');
			if (!submenuItems.length) return;

			const boxItem = document.createElement('div');
			boxItem.classList.add('privary-navigation__box');

			submenuItems.forEach((subItem) => {
				const wrapper = document.createElement('div');
				wrapper.classList.add('flex-box');

				const link = subItem.querySelector('a');
				if (!link) return;

				wrapper.innerHTML = `
					<div class="privary-navigation__box-image">
					<img src="" alt="" loading="lazy" data-navimg="${customCounter}">
					</div>
					<div class="privary-navigation__box-content"></div>
				`;

				const content = wrapper.querySelector('.privary-navigation__box-content');

				link.appendChild(wrapper);
				
				boxItem.appendChild(link);

				customCounter++;
			});

			submenu.remove();

			itemMenu.insertBefore(boxItem, itemMenu.firstChild);
		});

		const navImagesGoFrom = document.querySelectorAll('.header__navimg [data-navgo]');
		const navImagesGoTo = document.querySelectorAll('.privary-navigation__box [data-navimg]');

		const imageMap = {};

		navImagesGoTo.forEach(img => {
			imageMap[img.dataset.navimg] = img;
		});

		navImagesGoFrom.forEach(img => {
			const targetKey = img.dataset.navgo;
			if (imageMap[targetKey]) {
				imageMap[targetKey].src = img.src;
			}
		});
	} */

	/* if (window.innerWidth > 900) {
		const itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
		let customCounter = 0;

		itemsMenu.forEach((itemMenu) => {
			const submenu = itemMenu.querySelector('.submenu:not(.submenu .submenu)');
			if (!submenu) return;

			const submenuItems = submenu.querySelectorAll(':scope > li');
			if (!submenuItems.length) return;

			const boxItem = document.createElement('div');
			boxItem.classList.add('privary-navigation__box');

			submenuItems.forEach((subItem) => {
				const link = subItem.querySelector('a');
				if (!link) return;

				const text = link.textContent.trim();

				link.innerHTML = '';
				link.classList.add('privary-navigation__box-btn');

				const image = document.createElement('div');
				image.className = 'privary-navigation__box-image';
				image.innerHTML = `
					<img src="" alt="" loading="lazy" data-navimg="${customCounter}">
				`;

				const content = document.createElement('div');
				content.className = 'privary-navigation__box-content';
				content.textContent = text;

				link.appendChild(image);
				link.appendChild(content);

				boxItem.appendChild(link);

				customCounter++;
			});

			submenu.remove();
			itemMenu.insertBefore(boxItem, itemMenu.firstChild);
		});

		const navImagesGoFrom = document.querySelectorAll('.header__navimg [data-navgo]');
		const navImagesGoTo = document.querySelectorAll('.privary-navigation__box [data-navimg]');

		const imageMap = {};

		navImagesGoTo.forEach(img => {
			imageMap[img.dataset.navimg] = img;
		});

		navImagesGoFrom.forEach(img => {
			const targetKey = img.dataset.navgo;
			if (imageMap[targetKey]) {
			imageMap[targetKey].src = img.src;
			}
		});
	} */

	if (window.innerWidth > 900) {
		const itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
		let customCounter = 0;

		itemsMenu.forEach((itemMenu) => {
			const submenu = itemMenu.querySelector('.submenu:not(.submenu .submenu)');
			if (!submenu) return;

			const submenuItems = submenu.querySelectorAll(':scope > li');
			if (!submenuItems.length) return;

			const boxItem = document.createElement('div');
			boxItem.classList.add('privary-navigation__box');

			// 🔥 container wrapper
			const container = document.createElement('div');
			container.classList.add('container');

			submenuItems.forEach((subItem) => {
			const link = subItem.querySelector('a');
			if (!link) return;

			const text = link.textContent.trim();

			link.innerHTML = '';
			link.classList.add('privary-navigation__box-btn');

			const image = document.createElement('div');
			image.className = 'privary-navigation__box-image';
			image.innerHTML = `
				<img src="" alt="" loading="lazy" data-navimg="${customCounter}">
			`;

			const content = document.createElement('div');
			content.className = 'privary-navigation__box-content';
			content.textContent = text;

			link.appendChild(image);
			link.appendChild(content);

			// 👇 ahora va dentro del container
			container.appendChild(link);

			customCounter++;
			});

			// 👇 el container envuelve todo
			boxItem.appendChild(container);

			submenu.remove();
			itemMenu.insertBefore(boxItem, itemMenu.firstChild);
		});

		const navImagesGoFrom = document.querySelectorAll('.header__navimg [data-navgo]');
		const navImagesGoTo = document.querySelectorAll('.privary-navigation__box [data-navimg]');

		const imageMap = {};

		navImagesGoTo.forEach(img => {
			imageMap[img.dataset.navimg] = img;
		});

		navImagesGoFrom.forEach(img => {
			const targetKey = img.dataset.navgo;
			if (imageMap[targetKey]) {
			imageMap[targetKey].src = img.src;
			}
		});
	}
	
	let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');

	itemsMenu.forEach((itemMenu) => {
		const box = itemMenu.querySelector('.privary-navigation__box');
		if (!box) return;

		let timeout;

		itemMenu.addEventListener('mouseenter', () => {
			clearTimeout(timeout);

			itemMenu.classList.add('hover');
			box.classList.add('show');
		});

		itemMenu.addEventListener('mouseleave', () => {
			timeout = setTimeout(() => {
				if (box.matches(':hover')) return;

				itemMenu.classList.remove('hover');
				box.classList.remove('show');
			}, 120);
		});

		box.addEventListener('mouseenter', () => {
			clearTimeout(timeout);

			itemMenu.classList.add('hover');
			box.classList.add('show');
		});

		box.addEventListener('mouseleave', () => {
			timeout = setTimeout(() => {
				itemMenu.classList.remove('hover');
				box.classList.remove('show');
			}, 120);
		});
	});

	/** Skip to content functionality */
	document.addEventListener('keyup', (event) => {
			if (event.key === 'Tab') {
				const skipLink = document.querySelector('.skip-to-content');
				if (skipLink && !skipLink.hasBeenFocused) {
					skipLink.focus();
					skipLink.hasBeenFocused = true;
				}
			}
		});




})();